import React from "react";
import {
  Badge,
  ClickAwayListener,
  IconButton,
  InputAdornment,
  Paper,
  Popper,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class ZoneSaisieLibre extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      sousRubriqueIndex: this.props.sousRubriqueIndex,
      indicateurValue: this.props.indicateur.valeur ? this.props.indicateur.valeur.value : "",
    };
  }

  /**
   * On free input zone change, change the value of the indicateur
   * @param event
   */
  handleChange = (event) => {
    const newValue = event.target.value;
    this.setState({ indicateurValue: newValue });
    this.props.changeIndicateur(
      { ...this.props.indicateur, valeur: { value: newValue } },
      this.props.sousRubriqueIndex,
      this.props.libelleEnglobantIndex
    );
  };

  /**
   * Called when the free input zone button is clicked
   * @param event
   */
  handleOpenPopperNote = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  /**
   * Called on unfocused from the popper
   */
  handleClosePopperNote = () => {
    this.setState({ anchorEl: null });
  };

  /**
   * Render the free input zone
   * @returns {JSX.Element}
   */
  render() {
    const { indicateur } = this.props,
      { anchorEl, indicateurValue } = this.state;
    return (
      <React.Fragment>
        <div className={"ml-1"}>
          <Badge color="primary" overlap={"circular"} variant="dot">
            <Tooltip title={"ouvrir la zone de saisie libre"} placement={"right"}>
              <IconButton onClick={this.handleOpenPopperNote}>
                <FontAwesomeIcon icon="pencil-alt" />
              </IconButton>
            </Tooltip>
          </Badge>
          <Popper anchorEl={anchorEl} open={!!anchorEl} style={{ zIndex: 2 }} placement={"bottom-start"}>
            <ClickAwayListener onClickAway={this.handleClosePopperNote}>
              <Paper>
                <TextField
                  key={"indicateur-" + indicateur.idIndicateur}
                  value={indicateurValue}
                  indicateur={indicateur}
                  valueInputProps={
                    indicateur.libelleUnite != null && {
                      endAdornment: <InputAdornment position={"end"}>{indicateur.libelleUnite}</InputAdornment>,
                    }
                  }
                  onChange={this.handleChange}
                  label={"Zone de saisie libre"}
                  onBlur={this.handleClosePopperNote}
                  multiline
                  rows={4}
                  style={{
                    width: "35rem",
                  }}
                />
              </Paper>
            </ClickAwayListener>
          </Popper>
        </div>
      </React.Fragment>
    );
  }
}

export default ZoneSaisieLibre;
